var App = App || {};

App.SpeedBump = (function () {
    'use strict';

    const SPEEDBUMP_SELECTOR = "#SpeedBump";
    const SMART_BANNER_SELECTOR = ".smartbanner";
    let triggeredByModal = null;

    // Initializes the speed bump modal for the given anchor
    const initialize = (anchor) => {

        const speedBumpElement = document.querySelector(SPEEDBUMP_SELECTOR);
        if (!speedBumpElement) return false;
        const speedBumpModal = new bootstrap.Modal(speedBumpElement);

        if (requiresSpeedBump(anchor)) {

            checkModalParent(anchor);
            setProceedButton(speedBumpElement, speedBumpModal, anchor);

            speedBumpElement.addEventListener('show.bs.modal', event => {
                anchor.focus();
                anchor.blur();
                triggeredByModal = App.SpeedBump.getTriggeredByModal();
                if (triggeredByModal) {
                    triggeredByModal.hide();
                }
            })

            speedBumpElement.addEventListener('hidden.bs.modal', event => {
                anchor.focus();
                anchor.blur();
                triggeredByModal = App.SpeedBump.getTriggeredByModal();
                if (triggeredByModal) {
                    triggeredByModal.show();
                }
                App.SpeedBump.setTriggeredByModal(null);
            })

            speedBumpModal.show();
            return true;
        }
        return false;
    }


    // Reduces a hostname to a comparable form: lowercase, no trailing dot, no leading "www."
    const normalizeHostname = (hostname) => {
        const normalized = String(hostname || "").trim().replace(/\.$/, "").toLowerCase();
        return normalized.startsWith("www.") ? normalized.slice(4) : normalized;
    };

    // Determines if the speed bump modal is required for the anchor
    const requiresSpeedBump = (anchor) => {

        // The smart app banner links straight to the app stores and is never speed bumped
        if (anchor.closest(SMART_BANNER_SELECTOR)) return false;

        try {
            const url = new URL(anchor.getAttribute("href"));
            const href = url.href;
            const hostname = normalizeHostname(url.hostname);

            const exemptList = typeof SpeedbumpData !== 'undefined' ? [...SpeedbumpData.ExemptList] : [];
            const isExempt = exemptList.map(normalizeHostname).indexOf(hostname) !== -1;
            const isUriSchema = App.Helpers.isUriSchema(href);

            if (hostname === normalizeHostname(location.hostname) || isExempt || isUriSchema)
                return false;

            return true;
        }
        catch (e) {
            return false;
        }
    };

    // Sets the proceed button behavior in the speed bump modal
    const setProceedButton = (speedBumpElement, speedBumpModal, anchor) => {

        const href = anchor.getAttribute("href");
        const proceedButton = speedBumpElement.querySelector("button[data-speedbump='proceed']");

        proceedButton.onclick = () => {
            speedBumpModal.hide();
            window.open(href);
        };
    };

    // Checks if the anchor is inside another modal or offcanvas and stores its instance
    const checkModalParent = (anchor) => {

        let parentModalInstance;
        const parentModelElement = anchor.closest(".modal, .offcanvas");
        if (!parentModelElement) return;


        if (parentModelElement.classList.contains("modal")) {
            parentModalInstance = bootstrap.Modal.getInstance(parentModelElement);
        }
        else if (parentModelElement.classList.contains("offcanvas")) {
            parentModalInstance = bootstrap.Offcanvas.getInstance(parentModelElement);
        }

        App.SpeedBump.setTriggeredByModal(parentModalInstance);
    };

    return {
        initialize,
        getTriggeredByModal: () => triggeredByModal,
        setTriggeredByModal: (val) => { triggeredByModal = val; }
    };

})();